module.exports = __webpack_public_path__ + "img/plane.5f010775.png";